import { Box } from "@mui/material";
import MuiCard from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import React, { ReactElement } from "react";
import Button from "../buttons/Button";

interface CardProps {
  icon: ReactElement;
  children: ReactElement[] | ReactElement;
  buttonText?: string | ReactElement;
  onButtonClick?: () => void;
  width?: string | number;
  disabled?: boolean;
  withButton?: boolean;
}

const CardWithIcon: React.FC<CardProps> = ({
  children,
  icon,
  buttonText,
  onButtonClick,
  width,
  disabled,
  withButton = true,
}) => {
  return (
    <MuiCard style={{ width }}>
      <CardContent>
        <Box mb={2} textAlign={"center"}>
          {icon}
        </Box>
        {children}
      </CardContent>
      <CardActions>
        {withButton && (
          <Button
            size="small"
            onClick={() => onButtonClick?.()}
            disabled={disabled}
            color="primary"
            variant={"contained"}
            sx={{ backgroundColor: "#00796B" }}
          >
            {buttonText}
          </Button>
        )}
      </CardActions>
    </MuiCard>
  );
};

export default CardWithIcon;
